import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { CALL_API } from "common/API";
import {
  getUserRoleId,
  getMenuList,
  getallShiftCategoryList,
} from "redux/selectors";
import { connect } from "react-redux";
import EditShift from "organisms/EditShift";
import { bindActionCreators } from "redux";
import { setAllShiftCategoryList } from "redux/actions";

const ShiftCategories = ({
  menuList,
  userRoleId,
  saveAllShiftCategory,
  allShiftCategoryList,
}) => {
  const [displayShiftLoader, setDisplayShiftLoader] = useState(false);
  const [ShiftList, setShiftList] = useState(allShiftCategoryList);

  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];

  const getShiftList = async () => {
    try {
      setDisplayShiftLoader(true);
      const { response } = await CALL_API(`settings/shift/shift-category`, "get", {});
      if (Array.isArray(response)) {
        saveAllShiftCategory(response);
      }
      setDisplayShiftLoader(false);
    } catch (error) {
      console.log("[getShiftList], Error-->", error);
    }
  };

  useEffect(() => {
    getShiftList();
  }, [setShiftList]);

  useEffect(() => {
    setShiftList(allShiftCategoryList);
  }, [allShiftCategoryList]);

  const hasShift = Array.isArray(ShiftList) && ShiftList.length > 0;

  return (
    <Spin spinning={displayShiftLoader && !hasShift}>
      {hasShift ? (
        <EditShift
          isModalVisible={true}
          closeModal={() => {}}
          getShiftList={getShiftList}
          ShiftDetails={ShiftList[0]}
          viewOnly={
            Menulist?.find(
              (item) =>
                item?.key === "manage" &&
                item?.subMenu.find(
                  (subItem) =>
                    subItem?.key === "shift-categories" &&
                    subItem?.permission.edit
                )
            )
              ? false
              : true
          }
        />
      ) : (
        !displayShiftLoader && <p>No shift has been configured yet.</p>
      )}
    </Spin>
  );
};
const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  menuList: getMenuList(state),
  allShiftCategoryList: getallShiftCategoryList(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      saveAllShiftCategory: setAllShiftCategoryList,
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null
)(ShiftCategories);
